import React from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as ChartPageActions from "actions/ChartPageActions";


class ChartComponentLayoutChooser extends React.Component {
	handleLayoutChange(layoutType) {
		var layout = [];
		if (layoutType === "full") layout.push("full");
		if (layoutType === "2rows") layout.push("top", "bottom");
		if (layoutType === "3rows") layout.push("topof3", "middleof3", "bottomof3");
		if (layoutType === "2rows2cols") layout.push("top-left", "bottom-left", "top-right", "bottom-right");
		if (layoutType === "3rows2cols") {
			layout.push("topof3-left", "middleof3-left", "bottomof3-left",
				"topof3-right", "middleof3-right", "bottomof3-right");
		}
		this.props.onLayoutChange(layout);
	}
	render() {
		return (
			<div className="chart-layout" data-intro="Choose a layout, view up to 6 charts at a time" data-position="top">
				<div onClick={this.handleLayoutChange.bind(this, "full")}>
					<svg height="30" width="30">
						<rect x="4" y="4" height="22" width="22" stroke="black" strokeWidth="2" fill="none" />
					</svg>
				</div>
				<div onClick={this.handleLayoutChange.bind(this, "2rows")}>
					<svg height="30" width="30">
						<rect x="4" y="4" height="22" width="22" stroke="black" strokeWidth="2" fill="none" />
						<line x1="4" y1="15" x2="26" y2="15" stroke="black" strokeWidth="2" />
					</svg>
				</div>
				<div onClick={this.handleLayoutChange.bind(this, "3rows")}>
					<svg height="30" width="30">
						<rect x="4" y="4" height="22" width="22" stroke="black" strokeWidth="2" fill="none" />
						<line x1="4" y1="11" x2="26" y2="11" stroke="black" strokeWidth="2" />
						<line x1="4" y1="18" x2="26" y2="18" stroke="black" strokeWidth="2" />
					</svg>
				</div>
				<div onClick={this.handleLayoutChange.bind(this, "2rows2cols")}>
					<svg height="30" width="30">
						<rect x="4" y="4" height="22" width="22" stroke="black" strokeWidth="2" fill="none" />
						<line x1="4" y1="15" x2="26" y2="15" stroke="black" strokeWidth="2" />
						<line x1="15" y1="4" x2="15" y2="26" stroke="black" strokeWidth="2" />
					</svg>
				</div>
				<div onClick={this.handleLayoutChange.bind(this, "3rows2cols")}>
					<svg height="30" width="30">
						<rect x="4" y="4" height="22" width="22" stroke="black" strokeWidth="2" fill="none" />
						<line x1="4" y1="11" x2="26" y2="11" stroke="black" strokeWidth="2" />
						<line x1="4" y1="18" x2="26" y2="18" stroke="black" strokeWidth="2" />
						<line x1="15" y1="4" x2="15" y2="26" stroke="black" strokeWidth="2" />
					</svg>
				</div>
			</div>
		);
	}
}

function mapDispatchToProps(dispatch) {
	var { changeLayout } = bindActionCreators(ChartPageActions, dispatch);
	return { onLayoutChange: changeLayout };
}

export default connect(null, mapDispatchToProps)(ChartComponentLayoutChooser);


/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/ChartComponentLayoutChooser.jsx
 **/